(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["similar-products-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.ymSimilarProductsModalLoaded) return;
  window.ymSimilarProductsModalLoaded = true;

  var previousFocus = null;

  function qsa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getRouteRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function findRootByHandle(handle) {
    var roots = qsa('[data-ym-similar-root]');
    var normalizedHandle = String(handle || '');

    for (var i = 0; i < roots.length; i++) {
      if ((roots[i].getAttribute('data-product-handle') || '') === normalizedHandle) {
        return roots[i];
      }
    }

    return roots[0] || null;
  }

  function mountRootToBody(root) {
    if (!root || !document.body) return root;

    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    return root;
  }

  function mountAllRootsToBody() {
    qsa('[data-ym-similar-root]').forEach(function (root) {
      mountRootToBody(root);
    });
  }

  function getGa4Currency(root) {
    return (root && root.getAttribute('data-currency')) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'EUR';
  }

  function getGa4ListId() {
    return 'similar_products_modal';
  }

  function getGa4ListName() {
    return 'Productos similares';
  }
  function publishSimilarTracking(payload, clearEcommerce) {
  var shopifyAnalytics = window.Shopify && window.Shopify.analytics;

  if (!shopifyAnalytics || typeof shopifyAnalytics.publish !== 'function') {
    console.warn(
      '[YM Similar] Shopify.analytics.publish no disponible. Evento no enviado:',
      payload && payload.event
    );
    return;
  }

  function publish(data) {
    try {
      var result = shopifyAnalytics.publish('custom_event', data);

      if (result && typeof result.catch === 'function') {
        result.catch(function (error) {
          console.error(
            '[YM Similar] Error publicando evento:',
            error
          );
        });
      }

      return result;
    } catch (error) {
      console.error(
        '[YM Similar] Error publicando evento:',
        error
      );
      return null;
    }
  }

  if (clearEcommerce) {
    publish({
      ecommerce: null
    });
  }

  publish(payload);
}

  function centsToGa4Price(cents) {
    var value = Number(cents || 0) / 100;
    return Number.isFinite(value) ? value : 0;
  }

  function buildGa4Item(product, variant, source, position) {
    var productId = product && product.id != null ? String(product.id) : '';
    var productName = product && product.title ? String(product.title) : '';
    var variantId = variant && variant.id != null ? String(variant.id) : '';
    var price = variant && variant.price != null ? variant.price : (product && product.price != null ? product.price : 0);

    return {
      item_id: productId,
      item_name: productName,
      item_variant: variantId,
      item_list_id: getGa4ListId(),
      item_list_name: getGa4ListName(),
      index: Number(position || 0),
      price: centsToGa4Price(price),
      quantity: 1,
      recommendation_source: source || 'related'
    };
  }

  function trackSimilarIntent(root, size, triggerSource) {
  if (!root) return;

  var sourceProductId = root.getAttribute('data-product-id') || '';
  var sourceProductHandle = root.getAttribute('data-product-handle') || '';
  var contentId =
    'similar_products_' +
    (sourceProductHandle || sourceProductId || 'unknown');

  publishSimilarTracking({
    event: 'select_content',
    content_type: 'similar_products',
    content_id: contentId,
    selected_size: size || '',
    similar_trigger_source: triggerSource || '',
    source_product_id: sourceProductId,
    source_product_handle: sourceProductHandle
  }, false);
}

  function trackSimilarListView(root, size, items) {
  if (!root || !Array.isArray(items) || !items.length) return;

  var ga4Items = items.map(function (item, index) {
    return buildGa4Item(
      item.product,
      item.variant,
      item.source,
      index
    );
  });

  publishSimilarTracking({
    event: 'view_item_list',
    selected_size: size || '',
    source_product_id:
      root.getAttribute('data-product-id') || '',
    source_product_handle:
      root.getAttribute('data-product-handle') || '',
    ecommerce: {
      currency: getGa4Currency(root),
      item_list_id: getGa4ListId(),
      item_list_name: getGa4ListName(),
      items: ga4Items
    }
  }, true);
}

  function trackSimilarProductClick(link) {
  if (!link) return;

  var root = link.closest('[data-ym-similar-root]');
  var price = Number(
    link.getAttribute('data-ym-product-price') || 0
  );

  var item = {
    item_id:
      link.getAttribute('data-ym-product-id') || '',

    item_name:
      link.getAttribute('data-ym-product-title') || '',

    item_variant:
      link.getAttribute('data-ym-variant-id') || '',

    item_list_id:
      getGa4ListId(),

    item_list_name:
      getGa4ListName(),

    index:
      Math.max(
        Number(
          link.getAttribute('data-ym-product-position') || 1
        ) - 1,
        0
      ),

    price:
      Number.isFinite(price) ? price : 0,

    quantity: 1,

    recommendation_source:
      link.getAttribute('data-ym-similar-source') || ''
  };

  publishSimilarTracking({
    event: 'select_item',

    selected_size:
      link.getAttribute('data-ym-selected-size') || '',

    recommendation_source:
      link.getAttribute('data-ym-similar-source') || '',

    clicked_product_handle:
      link.getAttribute('data-ym-product-handle') || '',

    source_product_id:
      root
        ? root.getAttribute('data-product-id') || ''
        : '',

    source_product_handle:
      root
        ? root.getAttribute('data-product-handle') || ''
        : '',

    ecommerce: {
      currency:
        getGa4Currency(root),

      item_list_id:
        getGa4ListId(),

      item_list_name:
        getGa4ListName(),

      items: [item]
    }
  }, true);
}

  function setStatus(root, state) {
    var loading = root.querySelector('[data-ym-similar-loading]');
    var empty = root.querySelector('[data-ym-similar-empty]');
    var error = root.querySelector('[data-ym-similar-error]');

    if (loading) loading.hidden = state !== 'loading';
    if (empty) empty.hidden = state !== 'empty';
    if (error) error.hidden = state !== 'error';
  }

  function getSizeLabels(root) {
    var translated = (root.getAttribute('data-size-labels') || '').split('|').map(normalize).filter(Boolean);
    var defaults = ['size', 'talla', 'taille', 'taglia', 'tamanho'];
    return translated.concat(defaults);
  }

  function getSizePosition(product, root) {
    var labels = getSizeLabels(root);
    var options = Array.isArray(product && product.options) ? product.options : [];

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var optionName = typeof option === 'string' ? option : (option && option.name ? option.name : '');
      if (labels.indexOf(normalize(optionName)) !== -1) {
        return i + 1;
      }
    }

    var fallback = parseInt(root.getAttribute('data-size-position') || '0', 10);
    return fallback > 0 ? fallback : 2;
  }

  function getVariantOptionValue(variant, position) {
    if (!variant || !position) return '';

    var directValue = variant['option' + position];
    if (directValue != null && directValue !== '') return directValue;

    if (Array.isArray(variant.options) && variant.options[position - 1] != null) {
      return variant.options[position - 1];
    }

    return '';
  }

  function findAvailableVariantForSize(product, size, root) {
    if (!product || !Array.isArray(product.variants) || !size) return null;

    var position = getSizePosition(product, root);
    var wanted = normalize(size);

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant && variant.available === true && normalize(getVariantOptionValue(variant, position)) === wanted) {
        return variant;
      }
    }

    return null;
  }

  function getImageUrl(product, variant) {
    var candidate = variant && variant.featured_image ? variant.featured_image : null;

    if (!candidate && product) candidate = product.featured_image;
    if (!candidate && product && Array.isArray(product.images) && product.images.length) candidate = product.images[0];

    if (!candidate) return '';
    if (typeof candidate === 'string') return candidate;
    return candidate.src || candidate.url || '';
  }

  function formatMoney(cents, root) {
    var number = Number(cents || 0) / 100;
    var currency = root.getAttribute('data-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'es-ES';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(number);
    } catch (error) {
      return number.toFixed(2) + ' ' + currency;
    }
  }

  function getProductUrl(product, variant) {
    var root = getRouteRoot();
    var handle = product && product.handle ? product.handle : '';
    var url = root + 'products/' + encodeURIComponent(handle);

    if (variant && variant.id) {
      url += '?variant=' + encodeURIComponent(variant.id);
    }

    return url;
  }

  function buildCard(product, variant, root, source, position, size) {
    var imageUrl = getImageUrl(product, variant);
    var title = product && product.title ? product.title : '';
    var productId = product && product.id != null ? product.id : '';
    var productHandle = product && product.handle ? product.handle : '';
    var variantId = variant && variant.id != null ? variant.id : '';
    var price = variant && variant.price != null ? variant.price : (product.price || 0);
    var compareAt = variant && variant.compare_at_price != null ? variant.compare_at_price : null;
    var href = getProductUrl(product, variant);
    var recommendationSource = source || 'related';

    var mediaHtml = imageUrl
      ? '<img class="ym-similar-card__image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
      : '<div class="ym-similar-card__placeholder">' + escapeHtml(title) + '</div>';

    var compareHtml = '';
    if (compareAt && Number(compareAt) > Number(price)) {
      compareHtml = '<span class="ym-similar-card__compare-price">' + escapeHtml(formatMoney(compareAt, root)) + '</span>';
    }

    return '' +
      '<article class="ym-similar-card" data-ym-similar-source="' + escapeHtml(recommendationSource) + '">' +
        '<a' +
          ' class="ym-similar-card__link"' +
          ' href="' + escapeHtml(href) + '"' +
          ' data-ym-product-id="' + escapeHtml(productId) + '"' +
          ' data-ym-product-handle="' + escapeHtml(productHandle) + '"' +
          ' data-ym-product-title="' + escapeHtml(title) + '"' +
          ' data-ym-variant-id="' + escapeHtml(variantId) + '"' +
          ' data-ym-product-position="' + escapeHtml(position) + '"' +
          ' data-ym-product-price="' + escapeHtml(centsToGa4Price(price)) + '"' +
          ' data-ym-selected-size="' + escapeHtml(size) + '"' +
          ' data-ym-similar-source="' + escapeHtml(recommendationSource) + '"' +
        '>' +
          '<div class="ym-similar-card__media">' + mediaHtml + '</div>' +
          '<div class="ym-similar-card__info">' +
            '<p class="ym-similar-card__title">' + escapeHtml(title) + '</p>' +
            '<div class="ym-similar-card__price">' +
              '<span>' + escapeHtml(formatMoney(price, root)) + '</span>' +
              compareHtml +
            '</div>' +
          '</div>' +
        '</a>' +
      '</article>';
  }

  function getProductLimit(root) {
    var value = parseInt(root.getAttribute('data-product-limit') || '6', 10);

    if (!Number.isFinite(value) || value < 2) return 6;
    return Math.min(value, 12);
  }

  function getCollectionMaxPages(root) {
    var value = parseInt(root.getAttribute('data-collection-max-pages') || '5', 10);
    return value > 0 ? value : 5;
  }

  function getBreadcrumbCollectionUrl() {
    var links = qsa('.pdp_breadcrumb a[href*="/collections/"]');
    if (!links.length) return '';
    return links[links.length - 1].href || links[links.length - 1].getAttribute('href') || '';
  }

  function getProductKey(product) {
    if (!product) return '';
    if (product.id != null) return String(product.id);
    return product.handle ? 'handle:' + String(product.handle) : '';
  }

  function collectEligibleItems(products, size, root, seenProducts, source, limit) {
    var items = [];
    var list = Array.isArray(products) ? products : [];

    for (var i = 0; i < list.length; i++) {
      if (limit && items.length >= limit) break;

      var product = list[i];
      var key = getProductKey(product);
      if (!key || seenProducts[key]) continue;

      var variant = findAvailableVariantForSize(product, size, root);
      if (!variant) continue;

      seenProducts[key] = true;
      items.push({
        product: product,
        variant: variant,
        source: source
      });
    }

    return items;
  }

  function loadCollectionPage(root, collectionUrl, page) {
    root._ymCollectionPagePromises = root._ymCollectionPagePromises || {};
    if (root._ymCollectionPagePromises[page]) {
      return root._ymCollectionPagePromises[page];
    }

    var sectionId = root.getAttribute('data-collection-section-id') || 'ym-similar-collection-data';
    var url;

    try {
      url = new URL(collectionUrl, window.location.origin);
    } catch (error) {
      return Promise.resolve({ products: [], page: page, pages: 0 });
    }

    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));

    root._ymCollectionPagePromises[page] = fetch(url.toString(), {
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection fallback HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var jsonNode = documentFragment.querySelector('[data-ym-collection-json]');

        if (!jsonNode) {
          return { products: [], page: page, pages: 0 };
        }

        var payload = JSON.parse(jsonNode.textContent || '{}');
        return {
          products: Array.isArray(payload.products) ? payload.products : [],
          page: Number(payload.page || page),
          pages: Number(payload.pages || 0)
        };
      })
      .catch(function (error) {
        delete root._ymCollectionPagePromises[page];
        throw error;
      });

    return root._ymCollectionPagePromises[page];
  }

  function collectCollectionFallback(root, size, seenProducts, needed) {
    if (needed <= 0) return Promise.resolve([]);

    var collectionUrl = getBreadcrumbCollectionUrl();
    if (!collectionUrl) return Promise.resolve([]);

    var maxPages = getCollectionMaxPages(root);
    var currentPage = 1;
    var totalPages = null;
    var fallbackItems = [];

    function loadNextPage() {
      if (fallbackItems.length >= needed) return Promise.resolve(fallbackItems);
      if (currentPage > maxPages) return Promise.resolve(fallbackItems);
      if (totalPages != null && currentPage > totalPages) return Promise.resolve(fallbackItems);

      var pageToLoad = currentPage;
      currentPage += 1;

      return loadCollectionPage(root, collectionUrl, pageToLoad).then(function (payload) {
        if (payload.pages > 0) totalPages = payload.pages;

        var pageItems = collectEligibleItems(
          payload.products,
          size,
          root,
          seenProducts,
          'breadcrumb_collection',
          needed - fallbackItems.length
        );

        fallbackItems = fallbackItems.concat(pageItems);
        return loadNextPage();
      });
    }

    return loadNextPage();
  }

  function paintItems(root, size, items) {
    var grid = root.querySelector('[data-ym-similar-grid]');
    var empty = root.querySelector('[data-ym-similar-empty]');
    if (!grid) return;

    root._ymLastRenderedProducts = items.map(function (item, index) {
      return {
        source: item.source,
        productId: item.product && item.product.id,
        handle: item.product && item.product.handle,
        variantId: item.variant && item.variant.id,
        size: size,
        position: index + 1
      };
    });

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.textContent = 'No hemos encontrado productos disponibles en talla ' + size + '.';
      setStatus(root, 'empty');
      return;
    }

    setStatus(root, 'ready');
    grid.innerHTML = items.map(function (item, index) {
      return buildCard(item.product, item.variant, root, item.source, index + 1, size);
    }).join('');

    trackSimilarListView(root, size, items);
  }

  function renderProducts(root, size) {
    var grid = root.querySelector('[data-ym-similar-grid]');
    var empty = root.querySelector('[data-ym-similar-empty]');
    var products = root._ymRecommendationProducts || [];

    if (!grid) return;
    grid.innerHTML = '';

    root._ymRenderToken = (root._ymRenderToken || 0) + 1;
    var renderToken = root._ymRenderToken;

    if (!size) {
      if (empty) empty.textContent = 'Selecciona una talla para ver productos similares disponibles.';
      setStatus(root, 'empty');
      return;
    }

    var seenProducts = {};
    var currentProductId = root.getAttribute('data-product-id');
    if (currentProductId) seenProducts[String(currentProductId)] = true;

    var productLimit = getProductLimit(root);
    var relatedItems = collectEligibleItems(products, size, root, seenProducts, 'related', productLimit);

    if (relatedItems.length >= productLimit) {
      paintItems(root, size, relatedItems.slice(0, productLimit));
      return;
    }

    setStatus(root, 'loading');

    collectCollectionFallback(root, size, seenProducts, productLimit - relatedItems.length)
      .then(function (fallbackItems) {
        if (renderToken !== root._ymRenderToken) return;
        paintItems(root, size, relatedItems.concat(fallbackItems).slice(0, productLimit));
      })
      .catch(function () {
        if (renderToken !== root._ymRenderToken) return;
        paintItems(root, size, relatedItems.slice(0, productLimit));
      });
  }

  function loadRecommendations(root) {
    if (root._ymRecommendationsPromise) return root._ymRecommendationsPromise;

    var productId = root.getAttribute('data-product-id');
    var url = getRouteRoot() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related';

    setStatus(root, 'loading');

    root._ymRecommendationsPromise = fetch(url, {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        root._ymRecommendationProducts = Array.isArray(data && data.products) ? data.products : [];
        return root._ymRecommendationProducts;
      })
      .catch(function (error) {
        root._ymRecommendationProducts = [];
        root._ymRecommendationsPromise = null;
        setStatus(root, 'error');
        throw error;
      });

    return root._ymRecommendationsPromise;
  }

  function openModal(root, size) {
    if (!root) return;

    root = mountRootToBody(root);

    var modal = root.querySelector('[data-ym-similar-modal]');
    var select = root.querySelector('[data-ym-similar-select]');
    if (!modal || !select) return;

    previousFocus = document.activeElement;

    if (size) {
      var hasSize = qsa('option', select).some(function (option) {
        return normalize(option.value) === normalize(size);
      });

      if (hasSize) {
        for (var i = 0; i < select.options.length; i++) {
          if (normalize(select.options[i].value) === normalize(size)) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    }

    root.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ym-similar-modal-open');

    setTimeout(function () {
      var close = root.querySelector('.ym-similar-modal__close');
      if (close) close.focus();
    }, 20);

    loadRecommendations(root)
      .then(function () {
        renderProducts(root, select.value);
      })
      .catch(function () {
        setStatus(root, 'error');
      });
  }

  function closeModal(root) {
    if (!root) return;

    var modal = root.querySelector('[data-ym-similar-modal]');
    root.classList.remove('is-open');
    if (modal) modal.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('[data-ym-similar-root].is-open')) {
      document.body.classList.remove('ym-similar-modal-open');
    }

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
    previousFocus = null;
  }

  function openFromStickyEvent(detail) {
    detail = detail || {};
    var root = findRootByHandle(detail.productHandle);
    if (!root) return;

    trackSimilarIntent(root, detail.size || '', detail.source || 'sticky_atc');

    var open = function () {
      openModal(root, detail.size || '');
    };

    if (document.body.classList.contains('sticky-atc-modal-open')) {
      var stickyClose = document.getElementById('sticky-atc-close-btn');
      if (stickyClose) stickyClose.click();
      setTimeout(open, 380);
    } else {
      open();
    }
  }

  function syncGeneralTriggers() {
    qsa('[data-ym-similar-general]').forEach(function (trigger) {
      var fieldset = trigger.closest('.variant-picker__option--size');
      var hasUnavailableSimilarSize = fieldset && fieldset.querySelector('[data-ym-similar-size]');
      trigger.classList.toggle('is-visible', !!hasUnavailableSimilarSize);
    });
  }

  document.addEventListener('variant:change', function () {
    setTimeout(syncGeneralTriggers, 60);
  });

  document.addEventListener('click', function (event) {
    var sizeTrigger = event.target && event.target.closest ? event.target.closest('[data-ym-similar-size]') : null;

    if (sizeTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var sizeRoot = findRootByHandle(sizeTrigger.getAttribute('data-ym-product-handle'));
      var requestedSize = sizeTrigger.getAttribute('data-ym-similar-size') || '';

      trackSimilarIntent(sizeRoot, requestedSize, 'pdp_unavailable_size');
      openModal(sizeRoot, requestedSize);
      return;
    }

    var generalTrigger = event.target && event.target.closest ? event.target.closest('[data-ym-similar-general]') : null;

    if (generalTrigger) {
      event.preventDefault();
      event.stopPropagation();

      var generalRoot = findRootByHandle(generalTrigger.getAttribute('data-ym-product-handle'));
      var defaultSize = generalTrigger.getAttribute('data-ym-default-size') || '';

      trackSimilarIntent(generalRoot, defaultSize, 'pdp_ver_similares');
      openModal(generalRoot, defaultSize);
      return;
    }

    var productLink = event.target && event.target.closest ? event.target.closest('.ym-similar-card__link') : null;

    if (productLink) {
      trackSimilarProductClick(productLink);
      return;
    }

    var closeTrigger = event.target && event.target.closest ? event.target.closest('[data-ym-similar-close]') : null;
    if (closeTrigger) {
      event.preventDefault();
      closeModal(closeTrigger.closest('[data-ym-similar-root]'));
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches('[data-ym-similar-select]')) return;
    var root = event.target.closest('[data-ym-similar-root]');
    renderProducts(root, event.target.value);
  });

  document.addEventListener('keydown', function (event) {
    var sizeTrigger = event.target && event.target.matches && event.target.matches('[data-ym-similar-size]') ? event.target : null;

    if (sizeTrigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();

      var keyboardRoot = findRootByHandle(sizeTrigger.getAttribute('data-ym-product-handle'));
      var keyboardSize = sizeTrigger.getAttribute('data-ym-similar-size') || '';

      trackSimilarIntent(keyboardRoot, keyboardSize, 'pdp_unavailable_size');
      openModal(keyboardRoot, keyboardSize);
      return;
    }

    if (event.key === 'Escape') {
      var openRoot = document.querySelector('[data-ym-similar-root].is-open');
      if (openRoot) closeModal(openRoot);
    }
  });

  document.addEventListener('ym:similar-size', function (event) {
    openFromStickyEvent(event.detail);
  });

  mountAllRootsToBody();
  syncGeneralTriggers();
  setTimeout(function () {
    mountAllRootsToBody();
    syncGeneralTriggers();
  }, 250);
})();
  } catch(e) { console.error(e); }
})();

})();
